import { filterNonEmpty } from '../../utils/filterNonEmpty'
import type { BrandResult, BrandTabResult } from '../data/BrandFragment'
import type { ItemSubCategoryPreviewResult } from '../data/ItemSubCategoryFragment'
import type { ProductLineDetailResult } from '../data/ProductLineFragment'

export const selectFlavors = (
	brand: BrandTabResult | ProductLineDetailResult | BrandResult,
): ItemSubCategoryPreviewResult[] => {
	return brand.flavors.map((f) => f.itemSubCategory).filter(filterNonEmpty)
}
